import {
	pageLoading,
	pageLoaded,
	pageEntering,
	pageEntered,
	pageChanging,
	pageChanged,
	loadingRatio,
} from 'actions/global';

export const withLoader = (fn, store, page) => (nextState, cb) => {
	store.dispatch(pageLoading(page));

	fn(nextState, (error, component) => {
		cb(error, component);
		store.dispatch(pageLoaded(page));
	});
};

export const withSyncEnterLoader = (fn, store, page) => (nextState, replace, cb) => {
	store.dispatch(pageEntering(page));
	store.dispatch(loadingRatio(0, page));

	return fn(
		nextState,
		replace,
		ratio => store.dispatch(loadingRatio(ratio, page)),
		() => {
			cb();
			store.dispatch(loadingRatio(1));
			store.dispatch(pageEntered(page));
		},
	);
};

export const withSyncChangeLoader = (fn, store, page) => async (
	prevState,
	nextState,
	replace,
	cb,
) => {
	store.dispatch(pageChanging(page));
	store.dispatch(loadingRatio(0, page));

	return fn(
		prevState,
		nextState,
		replace,
		ratio => store.dispatch(loadingRatio(ratio, page)),
		() => {
			cb();
			store.dispatch(loadingRatio(1, page));
			store.dispatch(pageChanged(page));
		},
	);
};

export const withAsyncEnterLoader = (fn, store, page) => async (nextState, replace) => {
	store.dispatch(pageEntering(page));
	store.dispatch(loadingRatio(0, page));

	try {
		await fn(nextState, replace, ratio => store.dispatch(loadingRatio(ratio, page)));
	} catch (e) {
		console.log(`Exception on ${page}`, e);
	} finally {
		store.dispatch(loadingRatio(1, page));
		store.dispatch(pageEntered(page));
	}
};

export const withAsyncChangeLoader = (fn, store, page) => async (prevState, nextState, replace) => {
	store.dispatch(pageChanging(page));
	store.dispatch(loadingRatio(0, page));

	try {
		await fn(prevState, nextState, replace, ratio => store.dispatch(loadingRatio(ratio, page)));
	} catch (e) {
		console.log(`Exception on change ${page}`, e);
	} finally {
		store.dispatch(loadingRatio(1, page));
		store.dispatch(pageChanged(page));
	}
};



// WEBPACK FOOTER //
// ./src/util/routeHelper.js